import { PatientActions } from '../../actions/constant';

const {
  FAILURE_PATIENT_IN_ACTIVE_COUNT,
  SUCCESS_PATIENT_IN_ACTIVE_COUNT,
  SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING,
} = PatientActions;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getPatientActiveInActiveCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_PATIENT_IN_ACTIVE_COUNT: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case FAILURE_PATIENT_IN_ACTIVE_COUNT:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
